<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
    <path d="M12.75 6.75L6.75 0.75L0.75 6.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconChevronDown'
}
</script>
